import { Theme } from '@mui/material/styles'

const muiSelect = (theme: Theme) => {
  return {
    styleOverrides: {
      select: {
        minHeight: '1.5rem',
        lineHeight: 1.7,
        paddingTop: '0.565rem',
        paddingBottom: '0.565rem'
      },
      multiple: {
        minHeight: '1.5rem'
      },
      icon: {
        height: '1.875rem',
        width: '1.875rem',
        color: theme.colors.default,
        top: 'calc(50% - 1rem)'
      }
    }
  }
}

export default muiSelect
